import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/robots.txt")({
  server: {
    handlers: {
      GET: async () => {
        const robots = `# https://www.robotstxt.org/robotstxt.html
User-agent: *
Allow: /

# Private dashboard routes — authenticated only, not for crawlers
Disallow: /organizer/
Disallow: /company/
Disallow: /admin/
Disallow: /_student/
Disallow: /invite/

# Host & Sitemaps
Host: https://wefest.weskill.org
Sitemap: https://wefest.weskill.org/sitemap.xml
`;

        return new Response(robots, {
          headers: {
            "Content-Type": "text/plain",
            "Cache-Control": "public, max-age=86400",
          },
        });
      },
    },
  },
});

